module.exports = __webpack_public_path__ + "static/media/aika-win.6e044200.jpg";